import { AfterContentInit, Component, ContentChildren, QueryList, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { PuiMenuComponent } from './menu.component';

@Component({
  selector: 'pui-menu-main',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'menu-main.component.html'
})

export class PuiMenuMainComponent implements AfterContentInit, OnDestroy {
  /** @internal */
  private static _menus: Array<PuiMenuComponent> = [];

  @ContentChildren(PuiMenuComponent) menuList: QueryList<PuiMenuComponent>;

  get menus(): Array<PuiMenuComponent> {
    return this.menuList.length > 0 ? this.menuList.toArray() : PuiMenuMainComponent._menus;
  }

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngAfterContentInit() {
    // TODO: hacky way to get around the issue that 'menus' gets queried twice
    if (PuiMenuMainComponent._menus.length === 0 && this.menuList.length > 0) {
      PuiMenuMainComponent._menus = this.menuList.toArray();
    }
  }

  ngOnDestroy() {
    PuiMenuMainComponent._menus = [];
  }

  filter(term: string) {
    let regex = new RegExp(term, 'i');
    this.menus.forEach(menu => {
      let menuVisible = false; // !term || (menu.title && regex.test(menu.title));
      menu.items.forEach(item => {
        let itemVisible = false; // !term || (group.title && regex.test(group.title));
        if (item.group) {
          item.group.items.forEach(subItem => {
            subItem.visible = !term || (subItem.title && (regex.test(subItem.title) || (subItem.metadata && regex.test(subItem.metadata))));
            if (subItem.visible) {
              menuVisible = true;
              itemVisible = true;
            }
          });
          item.visible = itemVisible;
        } else {
          item.visible = !term || (item.title && (regex.test(item.title) || (item.metadata && regex.test(item.metadata))));
          if (item.visible) {
            menuVisible = true;
          }
        }
      });
      menu.visible = menuVisible;
    });
    this.changeDetector.markForCheck();
  }
}
